import * as React from "react";

const TrucSvg = ({ rackColor = "#001D3D" , ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="370"
    height="185"
    fill="none"
    viewBox="0 0 370 185"
    {...props}
  >
     <path
      d="m188.535 11.465 160 160 8.536 8.535H12.929l8.536-8.535 160-160L185 7.929z"
      fill="none"
      stroke="black"
      strokeWidth="11.5"
    />
    <path
      fill="#D7EAFF"
      stroke={rackColor}
      strokeWidth="9"
      d="m188.535 11.465 160 160 8.536 8.535H12.929l8.536-8.535 160-160L185 7.929z"
    ></path>
       

  </svg>
);

export default TrucSvg;

